import { Circle, Group, Image, Path } from "react-konva";
import { useImage } from "react-konva-utils";
import { Point } from "shared/datamodel/schemas/canvas-element";
import { CursorType } from "../cursor-type";
import { getPathPrefix } from "../../utils/getPathPrefix";
import { useIsCIMReorderEnabled } from "utils/url-utils";

const MarkerImage = getPathPrefix("/images/comment-marker.svg");

export default function AnnotationMarker({
  position,
  scale,
  photoURL,
}: {
  position?: Point;
  scale?: number;
  photoURL?: string;
}) {
  const isCimReorderEnabled = useIsCIMReorderEnabled();

  const [img, status] = useImage(MarkerImage);
  const [photo, photoStatus] = useImage(photoURL ?? "");
  const x = position?.x ?? 0;
  const y = position?.y ?? 0;

  if ((photoURL && photoStatus === "failed") || photoStatus === "loading") {
    return null;
  }

  if (isCimReorderEnabled && photoStatus === "loaded" && photoURL) {
    return (
      <Group>
        <Path
          data="M18.96 3c8.814 0 15.96 7.146 15.96 15.96 0 3.598-1.192 6.917-3.201 9.587-1.33 1.934-6.324 8.308-9.656 12.531a3.966 3.966 0 0 1-6.224.016c-3.56-4.473-8.999-11.375-9.857-12.843A15.9 15.9 0 0 1 3 18.96C3 10.146 10.146 3 18.96 3"
          fill="#fff"
          shadowColor="rgba(15,15,15,0.2)"
          shadowBlur={3}
          shadowOffset={{ x: 0, y: 0 }}
        />
        {photoURL ? (
          <Group>
            <Circle x={19} y={19} radius={11} />
            <Image x={9} y={8} image={photo} width={20} height={20} />
          </Group>
        ) : (
          <Circle x={19} y={19} radius={11} fill="#C4C4C4" />
        )}
      </Group>
    );
  }

  //TODO: cache the img for all thread elements
  return status == "loaded" ? (
    <Image
      name="annotation"
      x={x}
      y={y}
      scaleX={scale}
      scaleY={scale}
      image={img}
      offsetX={img!.width / 2}
      offsetY={img!.height}
      onMouseEnter={(e) => {
        const container = e.target.getStage()?.container()?.parentNode as HTMLElement;
        if (container) {
          const cursor = container.dataset.cursor ?? "pointer";
          if (cursor == CursorType.pointer) {
            const s = scale ?? 1;
            e.target.to({ scaleX: s * 1.2, scaleY: s * 1.2, duration: 0.1 });
            container.style.cursor = "pointer";
          }
        }
      }}
      onMouseLeave={(e) => {
        const s = scale ?? 1;
        if (e.target.scaleX() != s) e.target.to({ scaleX: s, scaleY: s, duration: 0.1 });
        const container = e.target.getStage()?.container()?.parentNode as HTMLElement;
        if (container) {
          const cursor = container.dataset.cursor ?? "pointer";
          if (cursor == CursorType.pointer) {
            container.style.cursor = "inherit";
          }
        }
      }}
    />
  ) : null;
}
